<dx-button id="mic" *ngIf="IsEnabled && (service.IsLoading | async) === false"  (onClick)="service.handleMicClick()" [disabled]="!service.mediaService.IsMicAvailable">
  <ng-template [ngIf]="service.mediaService.IsMicAvailable" [ngIfElse]="disabled">
    <i [ngClass]="{
    'ion ion-ios-mic-off': !service.mediaService.IsMicListening,
    'ion ion-ios-mic': service.mediaService.IsMicListening,
     'listening': service.mediaService.IsMicListening
     }">
      <div class="circles" *ngIf="service.mediaService.IsMicListening"
           [ngClass]="{'circles-red': service.mediaService.Timer <= 30}">
        <div class="circle1"></div>
        <div class="circle2"></div>
        <div class="circle3"></div>
      </div>
    </i>
  </ng-template>

  <ng-template #disabled>
    <i [ngClass]="{'ion ion-ios-mic-off': !service.mediaService.IsMicAvailable}"></i>
  </ng-template>
</dx-button>

<dx-popup [(visible)]="isPopUpVisible" [showCloseButton]="false">
  <dxi-toolbar-item location="after">
    <dx-button text="Accept" hint="Accept" (onClick)="close(false)">
      <i class="ion ion-ios-checkmark-empty"></i>
    </dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item location="after">
    <dx-button text="Discard" hint="Discard" (onClick)="close()">
      <i class="ion ion-ios-close-empty"></i>
    </dx-button>
  </dxi-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <dx-html-editor #editor valueType="html" height="100%">
    </dx-html-editor>
  </div>
</dx-popup>

<dx-load-indicator [visible]="(service.IsLoading | async) ?? false"></dx-load-indicator>
